import { createFeatureSelector, createSelector } from '@ngrx/store'
import { CalendarState } from '../state/calendar.state'

const getCalendarState = createFeatureSelector<CalendarState>('calendar')

export const getAllCalendarSummary = () =>
  createSelector(getCalendarState, state => {
    return state?.summary
  })

export const getCalendarDetails = () =>
  createSelector(getCalendarState, state => {
    return state?.details
  })
